export const updateFavicon = (newFavicon: string) => {
  const link: any =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = `${newFavicon}.ico`;
  document.head.appendChild(link);

  const title: any = document.querySelector('head title');
  title.textContent = newFavicon.toUpperCase();
};
